import { GenericServicesMotoristaService } from './generic-services-motorista.service';
import { Injectable } from '@angular/core';
import { MensagensService } from 'max-ng-lib';
import { HttpClient } from '@angular/common/http';
import { take, catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogoEmpresaService extends GenericServicesMotoristaService {

  constructor(private _mensagensService: MensagensService, private _httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this._mensagensService;
  }

  getHttpClient(): HttpClient {
    return this._httpClient;
  }

  getUrlRecurso(): string {
    return '/logoEmpresa';
  }

  getLogoEmpresa(): Observable<Blob> {
    return this.getHttpClient().get(`${this.getBaseURL()}${this.getUrlRecurso()}/logo`, { responseType: 'blob' });
  }

  excluirLogo() {
    return this.delete('/excluir');
  }
}
